export default {
  ExcelCheckBoxesNames: [],
};
